export class District
{    
    public  DistId :number;
    public  StateId : number;
    public  CountryId : number;
    public  DistName : string;
    public  DistCode : string;
    public  CreatedBy : string;
    public  IsActive : boolean;
}